// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3SUk-","footer":"ReportModalFilter_footer__2s_DJ"};